import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api/votes/`;

// Create Product
const createVote = async (formData) => {
  const response = await axios.post(API_URL, formData);
  return response.data;
};

// Get Products
const getVotes = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

// Delete Product
const deleteVote = async (id) => {
  const response = await axios.delete(API_URL + id);
  return response.data;
};

// Get Post
const getVote = async (id) => {
  const response = await axios.get(API_URL + id);
  return response.data;
};

// Update Product
const updateVote = async (id, formData) => {
  const response = await axios.patch(API_URL + id, formData);
  return response.data;
};

// Update Product
const addVote = async (id, formData) => {
  const response = await axios.put(API_URL + `vote/${id}`, formData);
  return response.data;
};

const voteService = {
  createVote,
  getVotes,
  deleteVote,
  getVote,
  updateVote,
  addVote,
};

export default voteService;
